export default __webpack_public_path__ + "static/media/job1.db4270ba.svg";